var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelFacebookFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#3B5998",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.573 18v-5.243H9v-2.356h1.573v-.76c0-2.35.35-3.641 3.145-3.641h1.093v2.141h-1.093c-.944 0-.802 1.134-.802 1.659v.601H15l-.617 2.356h-1.467V18z"
}))));
export default SvgGemChannelFacebookFilled;